import colors from "../../base/colors";
import typography from "../../base/typography";

const { text } = colors;
const { size } = typography;

const inputBase = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: text.primary,
    },
    input: {
      color: text.primary,
      fontSize: size.sm,

      "&::placeholder": {
        color: text.secondary,
        opacity: 1,
      },
    },
  },
};

export default inputBase;
